export default __webpack_public_path__ + "static/media/customFlowerStandDefaultImg.d1cbc86e.svg";